import { Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TimelineEventDot from '../TimelineEventDot';
import TimelineLink from '../TimelineLink';
import StatusPill from '../StatusPill';
import { formatDate } from '../../../utils/dateUtils';
import { COLORS, TYPOGRAPHY, SPACING } from '../../../constants/theme';

const { Text } = Typography;

const SubmissionEvent = ({ submission, referral }) => {
  const history = useHistory();
  const company = useSelector((state) => state.user.currentUser.company);
  const jobTitle = submission.job?.title || 'Unknown Position';
  const referrerName = `${referral.user?.firstName || ''} ${referral.user?.lastName || ''}`.trim();

  return {
    dot: <TimelineEventDot icon={MailOutlined} backgroundColor={COLORS.TIMELINE_SUBMISSION} />,
    color: '#434343',
    children: (
      <div style={{ paddingBottom: SPACING.LG, marginLeft: SPACING.SM }}>
        <div style={{ marginBottom: '4px' }}>
          <TimelineLink
            href={`/employees/${referral.user?.id}`}
            onClick={() => history.push(`/employees/${referral.user?.id}`)}
          >
            {referrerName}
          </TimelineLink>
          <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM, marginLeft: '6px' }}>
            emailed referral for
          </Text>
          {submission.job?.id ? (
            <TimelineLink
              href={`/jobs/${submission.job.id}`}
              onClick={() => history.push(`/jobs/${submission.job.id}`)}
              style={{ marginLeft: '4px' }}
            >
              {jobTitle}
            </TimelineLink>
          ) : (
            <Text strong style={{ fontSize: TYPOGRAPHY.FONT_SIZES.MD, color: '#262626', marginLeft: '4px' }}>
              {jobTitle}
            </Text>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACING.SM, flexWrap: 'wrap' }}>
          <Text type="secondary" style={{ fontSize: TYPOGRAPHY.FONT_SIZES.SM }}>
            {formatDate(submission.referralDate)}
          </Text>
          {submission.referralStatus && submission.referralStatus !== '-' && (
            <StatusPill status={submission.referralStatus} company={company} />
          )}
        </div>
      </div>
    ),
  };
};

export default SubmissionEvent;
